import React from 'react';

import classNames from 'classnames/bind';
import style from './List.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

const List = props => (
  <div>
    {props.articles.map(({ title, url }, idx) => (
      <div key={idx} className={ctx('link-container')}>
        <Link to={url} className={ctx('link')}>
          {title}
        </Link>
      </div>
    ))}
  </div>
);

export default List;
